import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-upgrade-suc",
  "use": "app-icon-upgrade-suc-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 24\" id=\"app-icon-upgrade-suc\"><g fill=\"#3DCCA6\" fill-rule=\"evenodd\"><path d=\"M20 8.889v1.449h-6v7H6v-7H0v-1.45L10 0l10 8.889zm-8 6.449v-7h4.37L10 2.676 3.63 8.338H8v7h4z\" fill-rule=\"nonzero\" /><path d=\"M6 18.838h8v1.5H6zM6 21.838h8v1.5H6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol